<template>
	<div class="voice-route-step">
		<div class="header move-handle">
			<div class="header-left" @click="expanded = !expanded">
				<div class="flex align-items-center gap-10">
					<icon type="dots-vertical" size="24px" />
					<strong>Record</strong> <span class="sub-value">Start recording the call</span>
				</div>
				<div>
					<div v-if="!expanded" class="expand-icon">
						<icon type="arrow-expand" size="20px" />
					</div>
					<div v-if="expanded" class="expand-icon">
						<icon type="arrow-collapse" size="20px" />
					</div>
				</div>
			</div>
			<div class="header-right">
				<div class="delete-icon">
					<icon type="delete" size="20px" @click="deleteStep" />
				</div>
			</div>
		</div>
		<div v-if="expanded" class="content">
			<div class="step-options">
				<div class="control-group">
					<div class="inner">
						<label class="control-label">Recording Options:</label>
						<div class="controls">
							<div class="field">
								<div class="field"><code-editor v-model.parse="localRouteStep.params.options" /></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<a href="https://www.twilio.com/docs/voice/twiml/record" target="_blank"
				><icon type="open-in-new" size="18px" /> TwiML Record Documentation</a
			>
		</div>
	</div>
</template>

<script>
import codeEditor from '@/components/forms/CodeEditor.vue';

export default {
	name: 'VoiceRouteRecordHandler',
	emits: ['update', 'delete'],
	components: {
		codeEditor,
	},
	props: {
		routeStep: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			default_config: {
				handler: 'Record',
				params: {
					options: {},
				},
			},
			expanded: false,
		};
	},
	computed: {
		localRouteStep: {
			get() {
				return this.routeStep;
			},
			set(new_value) {
				this.$emit('update', new_value);
			},
		},
	},
	methods: {
		deleteStep(event) {
			this.$confirm.require({
				target: event.currentTarget,
				group: 'voice_route_builder',
				message: 'Are you sure you want to delete this route step?',
				icon: 'pi pi-exclamation-circle',
				acceptClass: 'p-button-danger',
				acceptIcon: 'pi pi-trash',
				acceptLabel: 'Delete Route Step',
				rejectLabel: 'Cancel',
				accept: async () => {
					this.$emit('delete');
				},
			});
		},
	},
};
</script>
